import { render, staticRenderFns } from "./LixsaActionButton.vue?vue&type=template&id=651aecb6&scoped=true"
import script from "./LixsaActionButton.vue?vue&type=script&lang=js"
export * from "./LixsaActionButton.vue?vue&type=script&lang=js"
import style0 from "./LixsaActionButton.vue?vue&type=style&index=0&id=651aecb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651aecb6",
  null
  
)

export default component.exports